module.exports = __webpack_public_path__ + "static/media/icon_s.6b636e56.svg";